import { useEffect } from 'react';

const ConfirmModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText = 'Confirmer',
  cancelText = 'Annuler',
  type = 'danger',
  isLoading = false,
  icon = null
}) => {
  // Fermer avec Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen && !isLoading) {
        onCancel();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onCancel, isLoading]);

  // Bloquer le scroll du body quand la modale est ouverte
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const getIconByType = () => {
    if (icon) return icon;
    switch (type) {
      case 'danger':
        return 'fa-trash-can';
      case 'warning':
        return 'fa-right-from-bracket';
      case 'success':
        return 'fa-check';
      case 'info':
        return 'fa-circle-info';
      default:
        return 'fa-circle-question';
    }
  };

  const isDanger = type === 'danger';

  return (
    <div
      className="dna-modal-backdrop"
      onClick={isLoading ? undefined : onCancel}
      role="presentation"
    >
      <div
        className="dna-modal dna-confirm"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`dna-confirm-icon is-${type}`}>
          <i className={`fa-solid ${getIconByType()}`}></i>
        </div>

        <h3 id="confirm-modal-title">{title}</h3>
        <p>{message}</p>

        <div className="dna-confirm-actions">
          <button
            className="button button-soft"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            className={`button ${isDanger ? 'button-crimson' : 'button-dark'}`}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i>
                Traitement...
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
